import React, {useState} from 'react';
import Helmet from 'react-helmet';
import {
  Grid,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Button,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import MfaDialog from 'login/MfaDialog';
import History from 'util/History';
import {cognitoAuthenticate, requestMfaCode} from 'util/Authentication';

const ozgeneBlue = '#3357b8';

export default function Login(_props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showMfaDialog, setShowMfaDialog] = useState(false);
  const [mfaToken, setMfaToken] = useState('');
  const [mfaEmail, setMfaEmail] = useState('');
  const handleChangeUsername = ({target: {value}}) => setUsername(value);
  const handleChangePassword = ({target: {value}}) => setPassword(value);
  const handleClearPassword = () => {
    setPassword('');
  };
  const handleCloseMfaDialog = () => {
    setShowMfaDialog(false);
    setMfaToken('');
    setMfaEmail('');
  };
  const handleLogin = async () => {
    setErrorMessage('');
    if (username !== '' && password !== '') {
      setIsLoading(true);
      try {
        const {idToken, email} = await cognitoAuthenticate(username, password);

        await requestMfaCode(idToken);
        setMfaToken(idToken);
        setMfaEmail(email);
        setShowMfaDialog(true);
      } catch (err) {
        setErrorMessage(err.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div
      className="login_bg"
      style={{
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0% 30%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Helmet title="myOzgene" defer={false} />
      <Card
        style={{
          marginTop: '20px',
          padding: '20px 20px 20px 20px',
          backgroundColor: 'white',
          width: '300px',
          zDepth: '0',
        }}
      >
        <img
          src="/ozgene_logo.png"
          alt="logo"
          width="200"
          height="60"
          style={{
            marginRight: 'auto',
            marginLeft: 'auto',
            display: 'block',
          }}
        />
        <CardHeader title="Login to myOzgene" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <span style={{color: 'red'}}>{errorMessage}</span>
            </Grid>
            <Grid item xs={12}>
              <TextField
                helperText={username === '' ? 'Enter your Username' : ''}
                fullWidth
                variant="outlined"
                label="Username"
                onChange={handleChangeUsername}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="password"
                fullWidth
                variant="outlined"
                helperText={password === '' ? 'Enter your Password' : ''}
                label="Password"
                onChange={handleChangePassword}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                onClick={handleLogin}
                disabled={isLoading || username === '' || password === ''}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} style={{marginRight: 8}} />
                    Logging in...
                  </>
                ) : (
                  'Login'
                )}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                style={{
                  color: ozgeneBlue,
                  float: 'right',
                  padding: 0,
                  marginRight: 0,
                  fontSize: '10px',
                }}
                onClick={() => {
                  History.replace('/forgot-password');
                }}
                disabled={isLoading}
              >
                Forgot Password ?
              </Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <MfaDialog
        open={showMfaDialog}
        onClose={handleCloseMfaDialog}
        idToken={mfaToken}
        email={mfaEmail}
        onClearPassword={handleClearPassword}
      />
    </div>
  );
}
